// extracted by mini-css-extract-plugin
export default {"overviewLocation":"overviewLocation__MzZmZ","reviewsLink":"reviewsLink__ODJlY","yelpAverageRating":"yelpAverageRating__Y2FlM","titleLinks":"titleLinks__OTUzN"};